<template>
  <div class="domains-container">
    <h2 class="section-title">Arii de Expertiza</h2>
    <div class="cards">
      <div v-for="(domain, index) in domains" v-bind:key="index" class="card-item"> 
        <domain-card v-bind:domain="domain"></domain-card>
      </div>
    </div>
  </div>
</template>
<script>
import DomainCard from './DomainCard.vue';
export default {
  name: 'Domains',
  components: { DomainCard },
  data: function () {
    return {
      domains: [
        {
          icon: "fa fa-home",
          title: 'Drept civil',
          description: [
            'Contracte civile și comerciale (între profesioniști);',
            'Drepturi reale. Dreptul de proprietate, revendicarea și apărarea dreptului de proprietate asupra terenurilor și a celorlalte bunuri imobile și mobile;',
            'Apărarea drepturilor de creanță; revendicarea și recuperarea drepturilor de creanță;',
            'Succesiuni, dreptul de moștenire;',
            'Dreptul familiei.'
          ]
        },
        {
          icon: "fa fa-briefcase",
          title: 'Dreptul muncii',
          description: [
            'Asistarea și consultarea clienților în negocierile individuale sau colective de muncă;',
            'Asistarea și consultarea clienților în conflictele de muncă, anterior înregistrării acestora la instanța de judecată (cercetări disciplinare; negocieri ale conflictelor de muncă colective);',
            'Asistarea și reprezentarea clienților în litigiile având ca obiect conflicte de muncă;'
          ]
        },
        {
          icon: "fa fa-line-chart",
          title: 'Drept financiar si fiscal',
          description: [
            'Consultanță în domeniul dreptului fiscal: Impozite și taxe reglementate de Codul fiscal și de legi speciale; procedurile reglementate de Codul de procedură fiscală;'
          ]
        },
        {
          icon: "fa fa-building-o",
          title: 'Societăți comerciale',
          description: [
            'Constituirea de societăți comerciale: consultanță acordată clienților în etapa negocierilor între viitorii asociați; redactarea actelor constitutive, a actelor necesare înregistrării societății,',
            'Modificarea societăților comerciale: consultanță acordată clienților cu privire la modificarea actelor constitutive ale societății; transformarea societăților din forma juridică deja existentă în altă formă juridică (ex. din S.R.L. în S.A.);',
            'Litigii ale societăților / asociaților în legătură cu deciziile adoptate de majoritate; excluderea asociaților, etc.',
            'Consultanța acordată clienților pentru deschiderea procedurii insolvenței.',
          ]
        },
        {
          icon: "fa fa-files-o",
          title: 'Drept administrativ',
          description: ''
        },
        {
          icon: "fa fa-balance-scale",
          title: 'Alte domenii',
          description: [
            'Proprietate intelectuală, Concurență Comercială, Transporturi rutiere, feroviare și maritime; Protecția consumatorilor.'
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss">
@import "../scss/_variables.scss";
.cards {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  width: 75vw;
  margin: auto;

  .card-item {
    flex: 0 0 24%;
    background-color: #262626;
    color: $theme-color;
    text-align: center;
    padding: 20px;
    margin: 20px;
    height: 250px;
    border-radius: 5px;
    position: relative;

    &:hover {
      box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;    
    }
  }
  
  .title {
    color: $white;
  }
  .icon {
    font-size: 80px;
    height: 130px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1300px) {
  .card-item {
    flex: 0 1 calc(40% - 8px) !important;
  }
}
@media only screen and (min-width: 360px) and (max-width: 768px) {
  .card-item {
    flex: 0 1 calc(75% - 8px) !important;
  }
}
@media only screen and (max-width: 360px) {
  .card-item {
    flex: 0 1 calc(100% - 8px) !important;
  }
}
@media only screen and (max-width: 443px) {
  .cards {
    width: 85vw;
  }
}
</style>